/* eslint-disable no-nested-ternary */
import styled from "styled-components";
import { bp } from "theme";
import { isHostLaunchedMicrosite } from "utils";

export const CheckboxLabel = styled.label<{
	inline?: string;
	isSelected?: boolean;
	labelSide?: string;
}>`
	display: ${(props) => (props.inline ? "inline" : "block")};
	position: relative;
	cursor: pointer;
	font-size: 12px;
	user-select: none;
	padding: 12px 0;

	display: flex;
	align-items: center;

	span {
		margin: 0;
		font-size: 14px;
		line-height: 20px;
	}

	.labelSpan {
		margin-right: 18px;
		color: #8c8594;
	}

	input:checked {
		font-weight: 500;
	}

	${bp.md} {
		.labelSpan {
			font-size: 16px;
			line-height: 24px;
		}
	}

	${(props) =>
		props.labelSide === "right" &&
		`
		.labelSpan {
			margin-left: 18px;
			order: 2;
		}
	`}

	${(props) =>
		props.isSelected &&
		`

		.labelSpan {
			font-weight: 600;
			color: #190A28;
		}

		.checkmark::after {
			display: block;
		}
	`}
`;

export const Input = styled.input`
	position: absolute;
	opacity: 0;
	cursor: pointer;

	&:focus {
		& + span {
			box-shadow: 0px 0px 0px 4px #859fbc30;
		}
	}

	&:checked {
		& + span {
			box-shadow: none;
		}
	}

	&:disabled {
		& + span {
			opacity: 0.7;
			cursor: default;
		}
	}
`;

export const CheckMark = styled.span<{
	isSelected?: boolean;
	isRadioButton?: boolean;
	disabled?: boolean;
}>`
	order: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 20px;
	width: 20px;
	background-color: transparent;
	border-radius: ${(props) => (!props.isRadioButton ? "4px" : "50%")};
	box-shadow: none;
	border: ${(props) =>
		props.isSelected
			? "none"
			: props.disabled
			? "2px solid #D1CED4"
			: "2px solid #8c8594"};

	&:hover {
		box-shadow: ${(props) => (props.disabled ? "none" : "0px 0px 0px 4px #859fbc30")};
	}

	&::after {
		display: none;
		content: "";
		border-radius: none;
		width: 20px;
		height: 20px;
		background-color: transparent;
		background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.31 10.31 3.31 9.68 3.7 9.29C4.09 8.9 4.72 8.9 5.11 9.29L8 12.17L14.88 5.29C15.27 4.9 15.9 4.9 16.29 5.29C16.68 5.68 16.68 6.31 16.29 6.7L8.7 14.29C8.32 14.68 7.68 14.68 7.29 14.29Z' fill='%23208268'/%3E%3C/svg%3E%0A");
		background-repeat: no-repeat;
		z-index: 2;

		${(props) =>
			!props.isRadioButton &&
			!isHostLaunchedMicrosite() &&
			`
				background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.7778 0H2.22222C1 0 0 1 0 2.22222V17.7778C0 19 1 20 2.22222 20H17.7778C19 20 20 19 20 17.7778V2.22222C20 1 19 0 17.7778 0ZM8.56667 14.7667C8.13333 15.2 7.43333 15.2 7 14.7667L3.01111 10.7778C2.57778 10.3444 2.57778 9.64444 3.01111 9.21111C3.44444 8.77778 4.14444 8.77778 4.57778 9.21111L7.77778 12.4111L15.4222 4.76667C15.8556 4.33333 16.5556 4.33333 16.9889 4.76667C17.4222 5.2 17.4222 5.9 16.9889 6.33333L8.56667 14.7667V14.7667Z' fill='%231F8268'/%3E%3C/svg%3E"); 
		`}
		${(props) =>
			props.isRadioButton &&
			isHostLaunchedMicrosite() &&
			`background-image: url('data:image/svg+xml,<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.900391" y="0.399902" width="19.2" height="19.2" rx="9.6" fill="%23FFC600"/><path d="M13.5706 6.70402C13.978 6.33117 14.6106 6.35922 14.9834 6.76666C15.3314 7.14693 15.3302 7.7233 14.9972 8.10159L14.9208 8.17948L9.32234 13.3026C8.9108 13.6792 8.27818 13.6428 7.91072 13.2414L7.84091 13.1563L5.65204 10.1722C5.32538 9.72689 5.42159 9.10108 5.86691 8.77442C6.28255 8.46955 6.85542 8.53302 7.19553 8.90491L7.26471 8.9893L8.79447 11.0741L13.5706 6.70402Z" fill="%232F3043"/></svg>')`}
		${(props) =>
			!props.isRadioButton &&
			isHostLaunchedMicrosite() &&
			`background-image: url('data:image/svg+xml,<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.900391" y="0.399902" width="19.2" height="19.2" rx="2" fill="%23FFC600"/><path d="M13.5706 6.70402C13.978 6.33117 14.6106 6.35922 14.9834 6.76666C15.3314 7.14693 15.3302 7.7233 14.9972 8.10159L14.9208 8.17948L9.32234 13.3026C8.9108 13.6792 8.27818 13.6428 7.91072 13.2414L7.84091 13.1563L5.65204 10.1722C5.32538 9.72689 5.42159 9.10108 5.86691 8.77442C6.28255 8.46955 6.85542 8.53302 7.19553 8.90491L7.26471 8.9893L8.79447 11.0741L13.5706 6.70402Z" fill="%232F3043"/></svg>')`}
	}
`;
